import { DEFAULT_HOME_PAGE, REPLACE_STATE_ACTION } from './constants';
import { IRootState } from './core-store';
import { Tabs } from './types';

export const replaceState = (state: IRootState) => ({
    type: REPLACE_STATE_ACTION,
    payload: state,
});

export const isReplaceStateAction = (action: any): action is ReturnType<typeof replaceState> => {
    return action.type === REPLACE_STATE_ACTION;
};

export const getValidTabNameValue = (possibleTab: string | undefined, defaultValue = DEFAULT_HOME_PAGE): Tabs => {
    if (Object.values(Tabs).includes(possibleTab as Tabs)) {
        return possibleTab as Tabs;
    }

    return defaultValue;
};
